import i18n from '../../../build/services/vuei18n';

const possibleModes = {
    double: 2,
    triple: 3,
    four: 4,
    five: 5,
    six: 6,
};

export default {
    getDigitCapacityModes: () =>
        Object.entries(possibleModes).map(([key, value]) => ({
            labelForNumbersMode: i18n.t(`common.common_gameSetting_${key}DigitsNum`),
            labelForCharactersMode: value,
            value,
        })),
};
